import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { joinChildren } from "../misc/joinChildren";
import styles from "./ObjectMenu.scss";
import { IconButton } from "../input/IconButton";
import { Dismiss24Regular, LightbulbFilled, LightbulbRegular } from "@fluentui/react-icons";
import { Notch } from "./Notch";
import { Button } from "@fluentui/react-components";

export function ObjectMenuButton({ children, className, ...rest }) {
  return (
    <IconButton compactSm className={classNames(styles.objectMenuButton, className)} {...rest}>
      {children}
    </IconButton>
  );
}

ObjectMenuButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

export function ObjectMenu({
  children,
  title,
  onClose,
  onBack,
  onPrevObject,
  onNextObject,
  currentObjectIndex,
  objectCount,
  onToggleLights,
  lightsEnabled
}) {
  return (
    <>
      <Notch onClose={onBack} spaced>
        {lightsEnabled ? (
          <Button
            icon={<LightbulbRegular style={{ width: "18px", height: "18px" }} />}
            onClick={onToggleLights}
            aria-label="Turn Lights Off"
            appearance="transparent"
            size="small"
          />
        ) : (
          <Button
            icon={<LightbulbFilled style={{ width: "18px", height: "18px" }} />}
            onClick={onToggleLights}
            aria-label="Turn Lights On"
            appearance="transparent"
            size="small"
          />
        )}
      </Notch>
      <div className={styles.objectMenuContainer}>
        {/* <div className={styles.objectMenu}>
          <div className={styles.menu}>
            {joinChildren(children, () => (
              <div className={styles.separator} />
            ))}
          </div>
        </div> */}
        {/* {objectCount > 1 && (
          <div className={styles.pagination}>
            <IconButton onClick={onPrevObject}>
              <ArrowBackIcon width={24} height={24} />
            </IconButton>
            <p>
              {currentObjectIndex + 1}/{objectCount}
            </p>
            <IconButton onClick={onNextObject}>
              <ArrowForwardIcon width={24} height={24} />
            </IconButton>
          </div>
        )} */}
      </div>
    </>
  );
}

ObjectMenu.propTypes = {
  currentObjectIndex: PropTypes.number.isRequired,
  objectCount: PropTypes.number.isRequired,
  onPrevObject: PropTypes.func,
  onNextObject: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.node,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  onToggleLights: PropTypes.func,
  lightsEnabled: PropTypes.bool
};
